;(function () {
  'use strict'

  angular.module('contrast.org-stats').constant('ORG_STATS_CONSTANTS', {
    APP_BREAKDOWNS: {
      SCORES: 'scores',
      LANGUAGES: 'languages',
      TECHNOLOGIES: 'technologies',
      RECENT: 'recent',
      UNSEEN: 'unseen'
    },
    SERVER_BREAKDOWNS: {
      ENVIRONMENTS: 'environments',
      CONTAINERS: 'containers'
    },
    SERVER_EXPAND: {
      OFFLINE: 'offline',
      ONBOARDED: 'onboarded',
      DELETED: 'deleted'
    },
    APP_BREAKDOWN_SELECT: [
      {
        keycode: 'technologies',
        translationId: 'details_seebyTechnology'
      },
      {
        keycode: 'scores',
        translationId: 'details_seebyGrade'
      }
    ],
    SERVER_BREAKDOWN_SELECT: [
      {
        keycode: 'environments',
        translationId: 'details_seebyEnvironment'
      },
      {
        keycode: 'containers',
        translationId: 'details_seebyContainer'
      }
    ]
  })
})()
